<template>
  <div>
    <el-card class="mat12">
      <div class="main">
        <!-- <p class="title">项目编制</p> -->
        <div class="main-info">
          <el-col :span="6" class="name media_col">
            项目付款周期：
            <i class="num">{{ dataDesc.payback.payCycle }}</i>
          </el-col>


          <el-col :span="6" class="name media_col">
            项目付款节点：
            <i class="num">{{ dataDesc.payback.payNode }}</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            付款方式：
            <i class="num">{{ dataDesc.payback.payment  }}</i>
          </el-col>
          <el-col :span="6" class="name media_col" v-if="dataDesc.project.projectType != 3">
            是否核对考勤：
            <i class="num">{{ dataDesc.payback.checked ? "是" : "否" }}</i>
          </el-col>
        </div>
        <!-- {{dataDesc.payback.stages.length}} -->
        <div class="main-info" v-for="(item,index) in dataDesc.payback.stages" :key='index'>
          <el-col :span="6" class="name media_col">
            阶段{{index+1}}：
            <i class="num">{{item.schedule}}%</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            阶段{{index+1}}时间：
            <i class="num">{{item.ctime[0]}}至{{item.ctime[1]}}</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            阶段{{index+1}}备注：
            <i class="num">{{item.remark}}</i>
          </el-col>
        </div>


        <div class="main-info">

          <el-col :span="6" class="name media_col"
            v-if="dataDesc.payback.payCycle=='月付'&&(dataDesc.payback.payNode=='预付'||dataDesc.payback.payNode=='中付')">账期：
          </el-col>
          <el-col :span="6" class="name media_col"
            v-else-if="dataDesc.payback.payCycle=='季付'&&(dataDesc.payback.payNode=='预付'||dataDesc.payback.payNode=='中付')">
            账期：
          </el-col>
          <el-col :span="6" class="name media_col"
            v-else-if="dataDesc.payback.payCycle=='半年付'&&(dataDesc.payback.payNode=='预付'||dataDesc.payback.payNode=='中付')">
            账期：
          </el-col>
          <el-col :span="6" class="name media_col"
            v-else-if="dataDesc.payback.payCycle=='年付'&&(dataDesc.payback.payNode=='预付'||dataDesc.payback.payNode=='中付')">
            账期：
          </el-col>
          <el-col :span="6" class="name media_col" v-else-if="dataDesc.payback.payCycle=='一次性付清'">账期：
          </el-col>
          <el-col :span="6" class="name media_col"
            v-else-if="dataDesc.payback.payCycle=='阶段付'&&(dataDesc.payback.payNode=='预付'||dataDesc.payback.payNode=='中付')">
            账期：
          </el-col>
          <el-col :span="6" class="name media_col" v-else>
            账期：
            <i class="num">{{ dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'  }}</i>
            <i class="num mal10">天</i>
          </el-col>



          <el-col :span="6" class="name media_col" v-if="dataDesc.payback.paymentDays!==''">
            账期备注：
            <i class="num">{{
              dataDesc.payback.paymentRemark
                ? dataDesc.payback.paymentRemark
                : "无"
            }}</i>
          </el-col>
          <!--  </div>


        <div  class="main-info"> -->
          <el-col :span="(dataDesc.payback.payCycle=='一次性付清')?6:12" class="name media_col">
            项目回款日期：
            <i class="num" v-if="dataDesc.payback.payCycle!='季付'">
              <span v-if="dataDesc.payback.payCycle=='月付'">
                <span v-if="dataDesc.payback.payNode=='预付'">
                  当月1日之前
                </span>
                <span v-if="dataDesc.payback.payNode=='中付'">
                  当月15日
                  <el-popover placement="top" title="" width="360" trigger="hover">
                    <el-col style="text-align: center;margin: 5px 0;" :span="8"
                      v-for="(item,index) in ctime(Number(dataDesc.project.beginDate.split('-')[1]),15,Number(dataDesc.project.beginDate.split('-')[0]))"
                      :key="index">
                      {{item}}
                    </el-col>
                    <span slot="reference" class="el-icon-question"
                      style="font-size: 16px;color: rgb(102,156,252);"></span>
                  </el-popover>
                </span>
                <span v-if="dataDesc.payback.payNode=='后付'">
                  {{
               ( dataDesc.payback.paymentDays==''||dataDesc.payback.paymentDays==0)
                  ? "当月的服务费在次月第" + 1 + "日"
                  : "当月的服务费在次月第" + (Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)+1) + "日"
              }}

                  <el-popover placement="top" title="" width="360" trigger="hover">
                    <el-col style="text-align: center;margin: 5px 0;" :span="8"
                      v-for="(item,index) in ctime(Number(dataDesc.project.beginDate.split('-')[1]),1,Number(dataDesc.project.beginDate.split('-')[0]))" :key="index">
                      {{dateAddDays(dataArr[index].split('n')[0],(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)),dataArr[index].split('n')[1]).replaceAll('-','年')}}
                    </el-col>
                    <span slot="reference" class="el-icon-question"
                      style="font-size: 16px;color: rgb(102,156,252);"></span>
                  </el-popover>

                </span>
              </span>

              <span v-if="dataDesc.payback.payCycle=='半年付'">
                <span v-if="dataDesc.payback.payNode=='预付'">
                  1月1日前，6月1日前
                </span>
                <span v-if="dataDesc.payback.payNode=='中付'">
                  3月15日，9月15日
                </span>
                <span v-if="dataDesc.payback.payNode=='后付'">
                  {{
                   ( dataDesc.payback.paymentDays==''||dataDesc.payback.paymentDays==0)
                      ? "7月第" + 1 + "日"
                      : "7月第" + (Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)+1) + "日"
                  }}，
                  {{
                   ( dataDesc.payback.paymentDays==''||dataDesc.payback.paymentDays==0)
                      ? "次年1月第" + 1 + "日"
                      : "次年1月第" + (Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)+1) + "日"
                  }}
                </span>
              </span>


              <span v-if="dataDesc.payback.payCycle=='年付'">
                <span v-if="dataDesc.payback.payNode=='预付'">
                  1月1日前
                </span>
                <span v-if="dataDesc.payback.payNode=='中付'">
                  6月30日
                </span>
                <span v-if="dataDesc.payback.payNode=='后付'">
                  {{
                  ( dataDesc.payback.paymentDays==''||dataDesc.payback.paymentDays==0)
                     ? "次年1月第" + 1 + "日"
                     : "次年1月第" + (Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)+1) + "日"
                 }}
                </span>
              </span>

              <span v-if="dataDesc.payback.payCycle=='一次性付清'">
                {{dataDesc.payback.backDate}}
              </span>

              <span v-if="dataDesc.payback.payCycle=='阶段付'">
                <span v-if="dataDesc.payback.payNode=='预付'">
                  每个阶段时间开始日期之前
                </span>
                <span v-if="dataDesc.payback.payNode=='中付'">
                  每个阶段时间的中期日期
                </span>
                <span v-if="dataDesc.payback.payNode=='后付'">
                  {{
                       ( dataDesc.payback.paymentDays==''||dataDesc.payback.paymentDays==0)
                          ? "每个阶段时间后的第" + 1 + "日"
                          : "每个阶段时间后的第" + (Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:0)+1) + "日"
                      }}
                </span>
              </span>


            </i>

            <i class="num" v-if="dataDesc.payback.payCycle=='季付'">
              <span v-show="dataDesc.payback.payNode=='预付'">
                每季度1日之前
              </span>
              <span v-show="dataDesc.payback.payNode=='中付'">
                {{dateAddDays('2-15',0).split('-')[0]==year?'':'次年'}}
                {{dateAddDays('2-15',0).split('-')[1]}}
                {{dateAddDays('5-15',0).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('5-15',0).split('-')[1]}}
                {{dateAddDays('8-15',0).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('8-15',0).split('-')[1]}}
                {{dateAddDays('11-15',0).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('11-15',0).split('-')[1]}}
              </span>
              <span v-show="dataDesc.payback.payNode=='后付'">
                {{dateAddDays('4-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('4-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[1]}}
                {{dateAddDays('7-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('7-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[1]}}
                {{dateAddDays('10-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[0]==year?'':'次年'}}
                {{ dateAddDays('10-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[1]}}
                次年{{ dateAddDays('1-15',(Number(dataDesc.payback.paymentDays?dataDesc.payback.paymentDays:'0'))+1).split('-')[1]}}
              </span>
            </i>
          </el-col>

          <el-col v-if="dataDesc.payback.payCycle=='一次性付清'" :span="6" class="name media_col">
            项目回款备注：
            <i class="num">{{
              dataDesc.payback.backRemark ? dataDesc.payback.backRemark : "无"
            }}</i>
          </el-col>

        </div>




        <!-- <p class="title">人员标准</p> -->
        <div class="main-info" v-if="dataDesc.project.projectType != 3">
          <el-col :span="6" class="name media_col" v-if="dataDesc.payback.checked">
            提交考勤日期：
            <i class="num">每月{{ dataDesc.payback.sumbitAttendanceDate }}日</i>
          </el-col>
          <el-col :span="6" class="name media_col" v-if="dataDesc.payback.checked">
            提交考勤备注：
            <i class="num">{{
              dataDesc.payback.attendanceRemark
                ? dataDesc.payback.attendanceRemark
                : "无"
            }}</i>
          </el-col>
          <!-- </div>
        <div class="main-info" v-if="dataDesc.project.projectType != 3"> -->
          <el-col :span="6" class="name media_col">
            提交发票日期：
            <i class="num" v-if="dataDesc.payback.subbitInvoiceDate==''"> </i>
            <i class="num" v-else>每月{{ dataDesc.payback.subbitInvoiceDate }}日</i>
          </el-col>
          <el-col :span="6" class="name media_col">
            提交发票备注：
            <i class="num">{{
              dataDesc.payback.invoiceRemark
                ? dataDesc.payback.invoiceRemark
                : "无"
            }}</i>
          </el-col>

          <el-col :span="6" class="name media_col">
            回款负责人：
            <i class="num">{{ dataDesc.payback.charge }}</i>
          </el-col>

        </div>
        <div class="main-info">

          <!-- <el-col :span="6" class="name media_col">
            项目回款日期：
            <i class="num">{{
              dataDesc.payback.backDate
                ? "每月" + dataDesc.payback.backDate + "日"
                : "无"
            }}</i>
          </el-col> -->
          <!-- <el-col  :span="12" class="name media_col">
            提交回款备注：
            <i class="num">{{
              dataDesc.payback.backRemark ? dataDesc.payback.backRemark : "无"
            }}</i>
          </el-col> -->



        </div>

      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'CardProjectMoneyback',
    props: {
      dataDesc: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isyear: null,
        year: new Date().getFullYear(),
        dataArr: [],
      }
    },
    mounted() {
      // this.ctime(8,15)
      // console.log(this.dataDesc)
      // this.dateAddDays('10-01',31)
    },
    methods: {

      dateAddDays(dateStr, dayCount, year) {
        var year = year ? year : new Date().getFullYear()
        var dateTemp = (year + '-' + dateStr).split("-")
        var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]);
        var millSeconds = Math.abs(nDate) + (dayCount * 24 * 60 * 60 * 1000);
        var rDate = new Date(millSeconds);
        var year = rDate.getFullYear();
        var month = rDate.getMonth() + 1;
        if (month < 10) month = "0" + month;
        var date = rDate.getDate();
        if (date < 10) date = "0" + date;
        var resultDateStr = (year + "-" + month + "月" + date + '日');
        return resultDateStr;
      },
      ctime(month, day, year) {
        var data = new Date();
        var dataArr = []
        var xx = []
        data.setFullYear(year)
        data.setMonth(month );
        day = Number(day) < 10 ? '0' + day : day;
        for (var i = 0; i < 12; i++) {
          var m = data.getMonth() + 1
          data.setMonth(data.getMonth() + 1);
          m = m < 10 ? "0" + m : m;
          if (Number(m) == 12) {
            dataArr.push(data.getFullYear() - 1 + "年" + m + '月' + day + '日');
            xx.push(m + '-' + day + 'n' + (Number(data.getFullYear()) - 1))
          } else {
            dataArr.push(data.getFullYear() + "年" + m + '月' + day + '日');
            xx.push(m + '-' + day + 'n' + data.getFullYear())
          }
        }
        this.dataArr = xx
        return dataArr;
      }





    },
  }
</script>

<style lang="scss" scoped>
  .main {
    padding-top: 20px;
  }

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 20px;
  }

  .main-info {
    display: flex;
    flex-wrap: wrap;

    i {
      font-style: normal;
    }

    .name {
      font-weight: bold;
      // margin-right: 25px;
      margin-bottom: 20px;
    }

    .num {
      font-weight: 400;
    }
  }
</style>
